import React from 'react';
import { Box } from '@mui/material';
import UpgradePrompt from './UpgradePrompt';

/**
 * BlurredContent Component
 * 
 * Wraps content with blur effect and upgrade prompt overlay
 * Used for tier-gated features
 */
const BlurredContent = ({ 
  children, 
  requiredTier, 
  featureName,
  blurAmount = 10,
  showOverlay = true 
}) => {
  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* Blurred content */}
      <Box 
        sx={{ 
          filter: `blur(${blurAmount}px)`, 
          pointerEvents: 'none', 
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none'
        }}
      >
        {children}
      </Box>
      
      {/* Overlay with upgrade prompt */}
      {showOverlay && (
        <Box 
          sx={{ 
            position: 'absolute', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255, 255, 255, 0.03)',
            backdropFilter: 'blur(2px)',
            zIndex: 10
          }}
        >
          <UpgradePrompt 
            tier={requiredTier} 
            featureName={featureName}
          />
        </Box>
      )}
    </Box>
  );
};

export default BlurredContent;

